<script setup>
import { onMounted, ref } from 'vue';
import IconSearch from '../../../icons/IconSearch.vue';

const props = defineProps({
  placeholder: String,
  small: Boolean,
  large: Boolean,
  focused: Boolean,
});
const emit = defineEmits(['input']);

const model = ref('');
const inputEl = ref(null);
const visible = ref(false);

const handleInput = (e) => {
  emit('input', e);
};

const toggleVisible = () => {
  visible.value = !visible.value;
}

onMounted(() => {
  if (props.focused) {
    inputEl.value.focus();
  }
});
</script>

<template>
  <div
    class="input__container"
    :class="{
      'input__container--small': small,
      'input__container--large': large,
    }"
  >
    <span>
      <icon-search />
    </span>
    <input
      type="text"
      ref="inputEl"
      v-model="model"
      :placeholder="placeholder"
      aria-label="Search"
      @input="handleInput"
    />
  </div>
</template>

<style lang="scss" scoped>
.input__container {
  display: flex;
  flex: 1;
  align-items: center;
  column-gap: 4px;
  padding: 0 12px;
  height: 48px;
  width: 100%;
  border-radius: 28px;
  border: 1px solid #CEC3CE;
  transition: border-color 0.2s;
  font-size: 16px;
  line-height: 24px;
  overflow: hidden;

  span {
    display: flex;
  }

  input {
    border: none;
    outline: none;
    width: 100%;
    height: 100%;
    background-color: transparent;
    caret-color: #5e2f78;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #4B444D;
    text-indent: 5px;
  }

  &:focus-within {
    border: 2px solid #5e2f78;
    padding: 0 11px;
  }
}

.input__container--small {
  height: 32px;
  font-size: 14px;
  line-height: 20px;
}

.input__container--large {
  height: 58px;
  font-size: 20px;
  line-height: 28px;
}
</style>
